import { getCentroidFromLocationPoints } from './getCentroidFromLocationPoints';
import type { Geometry } from 'geojson';

export function getLatLongFromGeometry(
  geometry: Geometry | nullish
): { longitude: number; latitude: number } | null {
  if (!geometry) {
    return null;
  } else if (geometry.type === 'Point') {
    return {
      longitude: geometry.coordinates[0],
      latitude: geometry.coordinates[1],
    };
  } else if (geometry.type === 'LineString') {
    const linePoints = geometry.coordinates;
    const center = getCentroidFromLocationPoints(
      linePoints.map((point) => ({
        longitude: point[0],
        latitude: point[1],
      }))
    );
    if (!center) return null;

    return {
      longitude: center.longitude,
      latitude: center.latitude,
    };
  } else if (geometry.type === 'Polygon') {
    const polygonPoints = geometry.coordinates[0];
    const center = getCentroidFromLocationPoints(
      polygonPoints.map((point) => ({
        longitude: point[0],
        latitude: point[1],
      }))
    );
    if (!center) return null;

    return {
      longitude: center.longitude,
      latitude: center.latitude,
    };
  } else if (geometry.type === 'MultiPolygon') {
    const allOuterRingPoints = geometry.coordinates.flatMap(
      (polygon) => polygon[0] ?? []
    );
    const center = getCentroidFromLocationPoints(
      allOuterRingPoints.map((point) => ({
        longitude: point[0],
        latitude: point[1],
      }))
    );
    if (!center) return null;

    return {
      longitude: center.longitude,
      latitude: center.latitude,
    };
  } else {
    throw new Error('Unsupported geometry type');
  }
}
